import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllCouriers,
  selectCouriersState,
} from "../../reudx-toolkit/slice/onboardingSlice";
import { Flex, Avatar, Divider, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import CustomTitle from "../../components/CustomTitle";
import CustomParagraph from "../../components/CustomParagraph";
import CustomInput from "../../components/CustomInput";
import { getProviderImagePath } from "../../common/utils/imageUtils";

const TransportProviderForm = ({
  token,
  searchQuery,
  setSearchQuery,
  selectedProvider,
  setSelectedProvider,
  setModalOpen,
  setCourierID,
}) => {
  const dispatch = useDispatch();
  const { courierList, status } = useSelector(selectCouriersState);

  useEffect(() => {
    dispatch(fetchAllCouriers(token));
  }, [dispatch, token]);

  const filteredProviders = courierList.filter((provider) =>
    provider?.title?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  const rows = [];
  for (let i = 0; i < filteredProviders.length; i += 2) {
    rows.push(filteredProviders.slice(i, i + 2));
  }

  const handleSelect = (provider) => {
    setSelectedProvider(provider);
    setModalOpen(true);
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <>
        <div
          style={{
            position: "absolute",
            top: "40px",
            paddingTop: "0px",
            left: "0",
            padding: "0px 32px",
            width: "100%",
            background: "#fff",
            zIndex: "2",
          }}
        >
          <CustomTitle
            text="Add transport provider"
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={"10px"}
          />
          <CustomInput
          className="custom-input form-input-style"
            width={"98%"}
            bgColor="#F3F3F3"
            height="36px"
            textColor="#000000"
            borderRadius="20px"
            border="none"
            placeholderColor="#5E5E5E"
            placeholder="Search for a transport provider..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            prefix={
              <SearchOutlined
                style={{ color: "#000", fontSize: "12px", marginRight: "8px" }}
              />
            }
          />
        </div>
        {/* <div
          style={{
            position: "sticky",
            top: 0,
            background: "#fff",
            zIndex: 10,
            paddingBottom: "8px",
          }}
        >
          <CustomTitle
            text="Add transport provider"
            fontSize={20}
            fontWeight="700"
            color="#000"
            marginBottom="14px"
          />

          <CustomInput
            bgColor="#F3F3F3"
            height="36px"
            textColor="#000000"
            borderRadius="20px"
            border="none"
            placeholderColor="#5E5E5E"
            placeholder="Search for a transport provider..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            prefix={
              <SearchOutlined
                style={{ color: "#000", fontSize: "12px", marginRight: "8px" }}
              />
            }
          />
        </div> */}

        <div
          style={{
            flex: 1,
            // overflowY: "auto",
            paddingBottom: "130px",
            paddingTop: "62px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="custom-scrollbar"
        >
          {status === "loading" ? (
            <Flex justify="center" align="center" style={{ height: "100%" }}>
              {" "}
              <Spin />
            </Flex>
          ) : courierList.length > 0 ? (
            rows.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <Flex justify="space-between" gap={12}>
                  {row.map((provider) => {
                    const imagePath = getProviderImagePath(provider.title, 'transportProvider');
                    return (
                      <Flex
                        key={provider.id}
                        align="center"
                        justify="space-between"
                        style={{
                          flex: 1,
                          padding: "6px 0px",
                          borderRadius: "8px",
                          // background:
                          //   selectedProvider?.id === provider.id
                          //     ? "#F5F5F5"
                          //     : "#fff",
                          cursor: "pointer",
                          transition: "all 0.2s ease-in-out",
                        }}
                        className="custom-select"
                        onClick={() => handleSelect(provider)}
                      >
                        <Flex
                          align="center"
                          gap={10}
                          style={{ marginLeft: "6px" }}
                        >
                          <Avatar
                            size={34}
                            src={
                              <img
                                src={imagePath}
                                alt="avatar"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            }
                            style={{
                              backgroundColor: "#fff",
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#555",
                            }}
                          >
                            {provider.title.charAt(0)}
                          </Avatar>
                          <CustomParagraph
                            marginBottom={"0px"}
                            text={provider.title}
                            fontSize={12}
                            fontWeight={600}
                          />
                        </Flex>
                      </Flex>
                    );
                  })}

                  {row.length === 1 && <div style={{ flex: 1 }}></div>}
                </Flex>
                {rowIndex !== rows.length - 1 && (
                  <Divider style={{ margin: "6px 0" }} />
                )}
              </React.Fragment>
            ))
          ) : (
            <Flex justify="center" align="center" style={{ height: "100%" }}>
              <CustomParagraph
                text="No transport providers available"
                fontSize={14}
              />
            </Flex>
          )}
        </div>
      </>
    </div>
  );
};

export default TransportProviderForm;
